import { createContext, Dispatch, SetStateAction } from 'react';
import { TEditShipmentAccess } from '@types';

type TEditShipmentContext = {
	setTouched: Dispatch<SetStateAction<boolean>>;
	setETASubmission: Dispatch<SetStateAction<boolean>>;
	setUpdateCargoSubmission: Dispatch<SetStateAction<boolean>>;
	access: TEditShipmentAccess;
	/* Closes the dialog for a page that saved its own changes and is sending the user elsewhere. */
	closeDialog: () => void;
}

export const EditShipmentContext = createContext<TEditShipmentContext | null>(null);
